const doc = [({"ko":({"adminHotelMail":({"saveInformation":"{{type}}주의 사항을 저장하려면", "saveSetting":"메일 설정을 저장"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;